// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__783L3","question":"styles_question__fWQzU","description":"styles_description__14Ldw"};